// src/services/realTimeChatService.js
import apiClient from './apiClient';

const realTimeChatService = {
  // Crear un nuevo mensaje/chat
  createMessage: async (messageData) => {
    try {
      console.log('Sending message data to backend:', JSON.stringify(messageData, null, 2));
      const response = await apiClient.post('/realTimeChats', messageData);
      console.log('Response from backend:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating message:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Obtener el primer mensaje pendiente
  getFirstPendingMessage: async () => {
    try {
      console.log('Getting first pending message...');
      const response = await apiClient.get('/realTimeChats/pending');
      console.log('Pending message response:', response.data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        console.log('No pending messages found');
        return null;
      }
      console.error('Error getting pending message:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Obtener un chat específico con información de usuarios
  getChatWithUsers: async (chatId) => {
    try {
      console.log(`Getting chat with users for ID: ${chatId}`);
      const response = await apiClient.get(`/realTimeChats/getChatWithUsers/${chatId}`);
      console.log('Chat with users response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error getting chat with users:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Finalizar un chat específico por ID (usando params)
  finalizeRealTimeChat: async (chatId) => {
    try {
      console.log(`Finalizing real-time chat with ID: ${chatId}`);
      const response = await apiClient.put(`/realTimeChats/finalizeRealTimeChat/${chatId}`);
      console.log('Finalize chat response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error finalizing real-time chat:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Agregar un mensaje a un chat existente
  addMessageToChat: async (chatId, messageData) => {
    try {
      console.log(`Adding message to chat ${chatId}:`, JSON.stringify(messageData, null, 2));
      const response = await apiClient.put(`/realTimeChats/addMessage/${chatId}`, messageData);
      console.log('Add message response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error adding message to chat:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Finalizar un chat con mensaje final opcional (usando query params)
  finalizeChat: async (chatId, finalizationData = {}) => {
    try {
      console.log(`Finalizing chat with ID: ${chatId}`, JSON.stringify(finalizationData, null, 2));
      const response = await apiClient.put(`/realTimeChats/finalize?id=${chatId}`, finalizationData);
      console.log('Finalize chat with message response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error finalizing chat:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Método helper para crear un nuevo chat completo
  createNewChat: async (email, initialMessage, userIdCard) => {
    try {
      const chatData = {
        email: email,
        messages: [{
          idCard: userIdCard,
          message: initialMessage
        }],
        status: 'Pendiente'
      };
      
      return await realTimeChatService.createMessage(chatData);
    } catch (error) {
      console.error('Error creating new chat:', error);
      throw error;
    }
  },

  // Método helper para enviar mensaje del agente
  sendAgentMessage: async (chatId, agentIdCard, message) => {
    try {
      const messageData = {
        idCard: agentIdCard,
        message: message
      };
      
      return await realTimeChatService.addMessageToChat(chatId, messageData);
    } catch (error) {
      console.error('Error sending agent message:', error);
      throw error;
    }
  },

  // Método helper para finalizar chat con mensaje de despedida
  finalizeChatWithMessage: async (chatId, agentIdCard, finalMessage) => {
    try {
      const finalizationData = {
        idCard: agentIdCard,
        finalMessage: finalMessage
      };
      
      return await realTimeChatService.finalizeChat(chatId, finalizationData);
    } catch (error) {
      console.error('Error finalizing chat with message:', error);
      throw error;
    }
  }
};

export default realTimeChatService;